import { enableNetwork } from 'firebase/firestore';
import { withTimeout } from '../utils/withTimeout';
import { db } from './firebase';

const ENABLE_NETWORK_TIMEOUT_MS = 4000;

/**
 * Ask the SDK to reopen the backend connection after a tab was backgrounded.
 * No-op if the network is already enabled. Timed so a hung WebChannel cannot stall login.
 */
export async function kickFirestoreReconnect(): Promise<void> {
  try {
    await withTimeout(enableNetwork(db), ENABLE_NETWORK_TIMEOUT_MS, 'enableNetwork timed out');
  } catch {
    /* already enabled, SDK not ready, or hung */
  }
}
